import playerState, { playerTimeState } from '@audacy-clients/core/atoms/player';
import PlayerStateConnector from '@audacy-clients/core/components/StateConnectors/PlayerStateConnector';
import { useRecentlyPlayedPlaylist } from '@audacy-clients/core/hooks/useRecentlyPlayedPlaylist';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useResetRecoilState } from 'recoil';
import useToast from '~/state/toast';
import useMusicControl from './musicControl';

const WebPlayerStateConnector = (): JSX.Element => {
  useMusicControl();
  useRecentlyPlayedPlaylist();
  const { t } = useTranslation();
  const { showToast } = useToast();

  const resetPlayerState = useResetRecoilState(playerState);
  const resetPlayerTimeState = useResetRecoilState(playerTimeState);

  const resetPlayerStateAndShowToast = useCallback(() => {
    resetPlayerState();
    resetPlayerTimeState();
    showToast({
      title: t('playerControls.toast.errorPlaying'),
    });
  }, [resetPlayerState, resetPlayerTimeState, showToast, t]);

  const onError = useCallback((): void => {
    resetPlayerStateAndShowToast();
    showToast({
      title: t('global.contentUnavailable'),
    });
  }, [showToast, resetPlayerStateAndShowToast, t]);

  return <PlayerStateConnector onPlaybackError={onError} />;
};

export default WebPlayerStateConnector;
